import React from 'react';
import {observer} from "mobx-react-lite";
import {useAppState} from "@stores/AppStateContext";

import {MODALS} from "../modal-names";

import {SignUp} from "./SignUp";
import {Login} from "./Login";
import {ForgotPassword} from "./ForgotPassword";
import {FillInfo} from "./FillInfo";
import {Locked} from "./Locked";

export const AuthModalsManager = observer(() => {
    const appState = useAppState();
    const activeModalEntry = appState.modalController.top;
    switch (activeModalEntry?.name) {
        case MODALS.SIGN_UP:
            return <SignUp/>;
        case MODALS.LOGIN:
            return <Login/>;
        case MODALS.FORGOT_PASSWORD:
            return <ForgotPassword/>;
        case MODALS.FILL_INFO:
            return <FillInfo/>;
        case MODALS.LOCKED:
            return <Locked {...activeModalEntry.params}/>;
        default:
            return null;
    }
});
